import React, { useState } from "react";
import "./FAQ.css";
import { Accordion } from "react-bootstrap";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Common_Banner from "../common-components/common_banner/Common_Banner";
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";

const FAQ = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "FREQUENTLY ASKED QUESTIONS", link: "", isActive: true },
  ];

  const [activeKey, setActiveKey] = useState("0");

  return (
    <section className="FAQ">
      {/* <Common_Banner imgSrc={"/assets/images/faq/banner.png"} /> */}
      <Common_Banner_2 imgSrc="/assets/images/about_us/banner/Banner-01.png" title_text="FAQs"/>

      <div className="container">
        {/* <div className='top_div'>
                    <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                </div> */}

        <div className="faq_div">
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}
          >
            {[
              {
                question:
                  "What ingredients are used in your Chikki and Laddu products?",
                answer:
                  "Our products are made using high-quality natural ingredients such as jaggery, peanuts, sesame seeds, dry fruits, gram flour, ghee, and traditional Indian spices. We focus on authentic taste and freshness.",
              },
              {
                question: "Are your products freshly made?",
                answer:
                  "Yes, all our Chikki, Laddu, Khakhra, and snack products are prepared fresh in hygienic conditions to maintain the best taste and quality.",
              },
              {
                question: "Do your products contain preservatives?",
                answer:
                  "Most of our products are made with minimal or no artificial preservatives. We believe in providing traditional homemade-style snacks with natural ingredients.",
              },
              {
                question: "How should I store the products after opening?",
                answer:
                  "Store the products in an airtight container in a cool and dry place. This helps maintain freshness, crunchiness, and flavor for a longer time.",
              },
              {
                question: "Do you offer online delivery across India?",
                answer:
                  "Yes, we provide online ordering and delivery services across many locations in India. Delivery availability may vary depending on your location.",
              },
            ].map((item, key) => (
              <Accordion.Item eventKey={key.toString()} key={key}>
                <Accordion.Header>
                  <p className="question_text">{item.question}</p>

                  <div className="icon_holder">
                    <FontAwesomeIcon
                      icon={
                        activeKey === key.toString() ? faAngleUp : faAngleDown
                      }
                      className="icon_text"
                    />
                  </div>
                </Accordion.Header>

                <Accordion.Body>
                  <div className="answer_div">
                    <p className="faq_answer_text">{item.answer}</p>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
